<template>
    <div class="flex py-2 px-3 rounded-md border items-start" :class="[typeClasses.bg, typeClasses.border, { 'justify-center text-center': center }]">
        <i class="fa mr-2 mt-0.5 flex-shrink-0" :class="[typeClasses.icon, typeClasses.iconColor]"></i>
        <p class="text-xs mb-0" :class="typeClasses.text">
            <slot />
        </p>
    </div>
</template>

<script>
export default {
    name: 'Alert',

    props: {
        type: {
            type: String,
            default: 'warning',
            validator: (v) => ['warning', 'danger', 'success', 'info'].includes(v),
        },
        center: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        typeClasses() {
            const map = {
                warning: {
                    bg:        'bg-[#fff9e3]',
                    border:    'border-[#f5dfb9]',
                    icon:      'fa-exclamation-triangle',
                    iconColor: 'text-[#e59f50]',
                    text:      'text-[#80531c]',
                },
                danger: {
                    bg:        'bg-red-50',
                    border:    'border-red-300',
                    icon:      'fa-times-circle',
                    iconColor: 'text-red-500',
                    text:      'text-red-800',
                },
                success: {
                    bg:        'bg-green-50',
                    border:    'border-green-300',
                    icon:      'fa-check-circle',
                    iconColor: 'text-green-500',
                    text:      'text-green-800',
                },
                info: {
                    bg:        'bg-blue-50',
                    border:    'border-blue-300',
                    icon:      'fa-info-circle',
                    iconColor: 'text-blue-500',
                    text:      'text-blue-800',
                },
            };
            return map[this.type] || map.warning;
        },
    },
};
</script>
